import * as tslib_1 from "tslib";
import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
export var ConfigServiceToken = new InjectionToken('config.service');
var ConfigService = /** @class */ (function () {
    function ConfigService(http) {
        this.http = http;
    }
    ConfigService.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.http.get('/wdpr-web-dcl-homepage/config').toPromise()];
                    case 1:
                        _a.config = _b.sent();
                        return [2 /*return*/, this.config];
                }
            });
        });
    };
    ConfigService.prototype.getValue = function (key) {
        // Get value of config key:
        return this.config[key];
    };
    return ConfigService;
}());
export { ConfigService };
